export const getFormattedCount = (count: number): string => {
  if (count / 1000 < 1) return String(count);
  else return `${String((count / 1000).toFixed(0))}k`;
};
